module.exports = __webpack_public_path__ + "img/big.a44777df.jpg";